import request from "./request";
/**
 * 修改密码
 * @param passWord 新的密码
 */
export default async function updatePassWord(data = {}) {
  return await request.post("/spin/sysUser/updatePassWord", data);
}
